// Module
var code = "<div class=\"ui-grid-cell-contents\" title=\"{{row.entity.period}}\">\n    <div class=\"u-textCap\" ng-bind=\"row.entity.period\" smart-truncate></div>\n</div>";
// Exports
module.exports = code;